module.exports = __webpack_public_path__ + "img/notice-i-4.bd4aa6bd.png";